// Copyright (c) 2016 Deere & Company

import {combineReducers} from 'redux';
import {getCombinedReducers as getCombinedLaborAdditiveReducers} from './labor-additive/reducers';
import {getCombinedReducers as getCombinedOpenPipsReducers} from './open-pips/reducers';
import {getCombinedReducers as getCombinedPipCodeRequestReducers} from './pip-code/reducers';
import {getCombinedReducers as getCombinedPipDetailsReducers} from './pip-details/reducers';
import {getCombinedReducers as getCombinedPipSearchReducers} from './pip-search/reducers';
import searchDropDown from './shared/reducers/search-dropdown';
import searchQueryString from './shared/reducers/search-query-string';

export const getCombinedReducers = () => combineReducers({
    details: getCombinedPipDetailsReducers(),
    laborAdditive: getCombinedLaborAdditiveReducers(),
    openPips: getCombinedOpenPipsReducers(),
    pipCodeRequest: getCombinedPipCodeRequestReducers(),
    pipSearch: getCombinedPipSearchReducers(),
    searchDropDown,
    searchQueryString
});




// WEBPACK FOOTER //
// ./src/pip/pip-reducers.js